import React from "react";
import Result from "../components/Result";

const PaymentCancellation = () => {
  return <Result type="payment" result="cancellation" />;
};

export default PaymentCancellation;
